import { useMemo } from 'react';
import { isArray } from 'radash';
import { TextAsset } from '@/Pages/PostsListPage/types';
import { getClipReadOnlyPlayerConfig } from '@/player-config/src/utils/clipUtils';
import { useAllVisibleClips } from '@/hooks/useAllVisibleClips';
import { getBlogAssetIds, getPostType, getSocialClipId } from '@/libs/postUtils';

export const useIsPostUsingRemotion = (post: TextAsset | null) => {
  const { allVisibleClips } = useAllVisibleClips();

  const areClipsApplicable = useMemo(() => {
    return ['LINKEDIN', 'BLOG'].includes(getPostType(post) ?? '');
  }, [post]);

  const clips = useMemo(() => {
    if (!areClipsApplicable) {
      return null;
    }
    if (getPostType(post) === 'LINKEDIN') {
      const socialClipId = getSocialClipId(post);
      return allVisibleClips.filter(clip => clip.id === socialClipId);
    }
    if (getPostType(post) === 'BLOG') {
      const blogAssetIds = getBlogAssetIds(post);
      if (!isArray(blogAssetIds)) {
        return null;
      }
      return allVisibleClips.filter(clip => blogAssetIds.includes(clip.asset_metadata.id));
    }
    return null;
  }, [post, allVisibleClips, areClipsApplicable]);

  const playerConfigExists = useMemo(() => {
    if (!areClipsApplicable || !isArray(clips)) {
      return null;
    }
    if (allVisibleClips.length === 0) {
      return false;
    }
    if (clips.length === 0) {
      return null;
    }
    return clips.every(clip => !!getClipReadOnlyPlayerConfig(clip));
  }, [clips, areClipsApplicable, allVisibleClips]);

  return {
    playerConfigExists
  };
};
